export const alertTypeIconVariants = {
  initial: { x: 20, y: 12, opacity: 1 },
  hovering: { opacity: 0, x: 0, zIndex: 1, transition: { duration: 0.3, ease: 'easeOut' } },
  exit: { x: 20, opacity: 1 },
};

export const actionButtonVariants = {
  initial: { opacity: 0, bottom: -30, right: 0 },
  hovering: { opacity: 1, bottom: -10 },
  exit: { bottom: -30, opacity: 0 },
};

export const buttonAnimation = {
  hidden: { x: 50, transition: { duration: 0.4 } },
  show: { x: 0, transition: { delay: 0.1 } },
  exit: { x: 50, scale: 0, opacity: 0 },
};

export const newButtonAnimation = {
  hidden: { opacity: 0, x: 50, y: 12 },
  hovering: { opacity: 1, x: 30, transition: { duration: 0.3, ease: 'easeOut' } },
  exit: { x: 30, scale: 0, opacity: 0 },
};
